import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import dayjs from 'dayjs';
import {
    Button,
    Input,
    Card,
    Form,
    Typography,
    Space,
    Modal,
    Checkbox,
    DatePicker,
    message,
    InputNumber,
    Select,
    Col,
    Row,
    Table,
} from 'antd';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
import { Right } from '@icon-park/react';
const pageKey = 'BookTaskList'; //页面身份
export default function BookTaskList() {
    const [dataSource, setData] = useState([]);
    const [deVal, setDeVal] = useState([]);
    // const [pageKey, setPageKey] = useState(pageKey);
    const [form] = Form.useForm();
    const [newForm] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [pageSize, setSize] = useState([]);
    const [total, setTol] = useState([]);
    const [current, setPage] = useState([]);
    const { data: startPortOptions } = useGetStartPortQuery(0);
    const { data: endPortOptions } = useGetEndPortQuery(0);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formSearch] = Form.useForm();
    const [promptText, setPromptText] = useState([]);
    const [hostOptions, setOptions] = useState([]);

    const loading = () => {
        ajax.get('maersk/book/task?group_id=1000')
            .then((response) => {
                let data = response.data;
                setTol(response.pagination.total);
                const newRes = response.data.map((item) => {
                    if (item.is_order === 0) {
                        item.is_order = '关闭';
                    } else if (item.is_order === 1) {
                        item.is_order = '开启';
                    }
                    if (item.is_USA === 0) {
                        item.is_USA = '否';
                    } else if (item.is_USA === 1) {
                        item.is_USA = '是';
                    }
                    if (item.is_plan === 0) {
                        item.is_plan = '否';
                    } else if (item.is_plan === 1) {
                        item.is_plan = '是';
                    }
                    if (item.is_cid == 0) {
                        item.is_cid = '关闭';
                    } else if (item.is_cid == 1) {
                        item.is_cid = '常规初始化';
                    } else if (item.is_cid == 2) {
                        item.is_cid = '加载更多初始化';
                    } else {
                        item.is_cid = item.is_cid ? item.is_cid : '';
                    }
                    item.update_cid_time = item.update_cid_time ? item.update_cid_time : '';
                    item.route_select = item.route_select ? item.route_select : '';
                    item.cid_group = item.cid_group ? item.cid_group : '';
                    item.group_id = item.group_id ? item.group_id : '';
                    // item.get_cid_times = item.get_cid_times ? item.get_cid_times : '';
                    return item;
                });
                setData(newRes);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        loading();
    }, []);
    const csh = (row) => {
        if (row.is_order === '开启') {
            row.is_order = 1;
        } else if (row.is_order === '关闭') {
            row.is_order = 0;
        }
        if (row.is_USA === '是') {
            row.is_USA = 1;
        } else if (row.is_USA === '否') {
            row.is_USA = 0;
        }
        if (row.is_plan === '是') {
            row.is_plan = 1;
        } else if (row.is_plan === '否') {
            row.is_plan = 0;
        }
        if (row.is_cid === '常规初始化') {
            row.is_cid = 1;
        } else if (row.is_cid === '关闭') {
            row.is_cid = 0;
        } else if (row.is_cid === '加载更多初始化') {
            row.is_cid = 2;
        } else if (row.is_cid === '3') {
            row.is_cid = 3;
        }
    };
    const save = async (id) => {
        try {
            const row = await form.validateFields();
            csh(row);
            let params = {
                ...row,
                id: id,
            };

            ajax.post('/maersk/book/task', params)
                .then((response) => {
                    message.success(response);
                    loading();
                })
                .catch((err) => {
                    console.log(err);
                });
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const EditableCell = ({
        editing,
        inputType,
        dataIndex,
        title,
        inputTypeBox,
        inputTypeStart,
        inputTypeEnd,
        openTypeSelect,
        PlanSelect,
        openTypeUSA,
        CIDTypeSelect,
        record,
        index,
        children,
        inputTypeDate,
        ...restProps
    }) => {
        let inputNode;
        if (inputType === 'number') {
            inputNode = <InputNumber />;
        } else {
            inputNode = <Input />;
        }
        if (openTypeSelect === 'select') {
            inputNode = <Select style={{ width: 80 }} options={createJsonOptions(['开启', '关闭'])} showSearch allowClear></Select>;
        }
        if (PlanSelect === 'select') {
            inputNode = <Select style={{ width: 80 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>;
        }
        if (openTypeUSA === 'select') {
            inputNode = <Select style={{ width: 80 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>;
        }
        if (CIDTypeSelect === 'select') {
            inputNode = (
                <Select
                    style={{ width: 120 }}
                    options={createJsonOptions(['关闭', '常规初始化', '加载更多初始化', '3'])}
                    showSearch
                    allowClear
                ></Select>
            );
        }
        if (inputTypeBox === 'select') {
            inputNode = (
                <Select
                    style={{ width: 100 }}
                    options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                    showSearch
                    allowClear
                ></Select>
            );
        }
        if (inputTypeStart === 'select') {
            inputNode = <Select style={{ width: 180 }} options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>;
        }
        if (inputTypeEnd === 'select') {
            inputNode = <Select style={{ width: 180 }} options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>;
        }
        if (inputTypeDate === 'date') {
            inputNode = (
                <Space direction="vertical">
                    <DatePicker style={{ width: 100 }} defaultValue={deVal} onChange={onChange} format="YYYY-MM-DD" />
                </Space>
            );
        }

        return (
            <td>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const isEditing = (record) => record.id === editingKey;

    const onChange = (val) => {
        form.setFieldsValue({
            order_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    const edit = (record) => {
        setDeVal(dayjs(record.order_date));
        form.setFieldsValue({
            id: record.id,
            order_id: record.order_id,
            account_name: record.account_name,
            box_type: record.box_type,
            origincity_name: record.origincity_name,
            destinationcity_name: record.destinationcity_name,
            order_date: record.order_date,
            is_order: record.is_order,
            limit_price: record.limit_price,
            is_USA: record.is_USA,
            is_plan: record.is_plan,
            cid_group: record.cid_group,
            group_id: record.group_id,
            route_select: record.route_select,
            ...record,
        });
        setEditingKey(record.id);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 80,
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '对应taskID',
            dataIndex: 'order_id',
            width: 80,
            editable: true,
            sorter: (a, b) => a?.order_id - b?.order_id,
        },
        {
            title: '账户名',
            dataIndex: 'account_name',
            width: 150,
            editable: true,
            sorter: (a, b) => a['account_name'].localeCompare(b['account_name']),
        },
        {
            title: '数量',
            dataIndex: 'quantity',
            width: 100,
            editable: true,
            sorter: (a, b) => a?.quantity - b?.quantity,
        },
        {
            title: '箱型',
            dataIndex: 'box_type',
            width: 180,
            editable: true,
            sorter: (a, b) => a['box_type'].localeCompare(b['box_type']),
        },
        {
            title: '起始港',
            dataIndex: 'origincity_name',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['origincity_name'].localeCompare(b['origincity_name']),
        },
        {
            title: '目的港',
            dataIndex: 'destinationcity_name',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['destinationcity_name'].localeCompare(b['destinationcity_name']),
        },
        {
            title: '搜索开航日',
            dataIndex: 'order_date',
            width: 150,
            editable: true,
            sorter: (a, b) => a['order_date'].localeCompare(b['order_date']),
        },
        {
            title: '美线',
            dataIndex: 'is_USA',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['is_USA'].localeCompare(b['is_USA']),
        },
        {
            title: '路由',
            dataIndex: 'route_select',
            // width: 120,
            editable: true,
            sorter: (a, b) => a['route_select'].localeCompare(b['route_select']),
        },
        {
            title: '是否开启',
            dataIndex: 'is_order',
            width: 120,
            editable: true,
            sorter: (a, b) => a['is_order'].localeCompare(b['is_order']),
        },
        {
            title: '限价',
            dataIndex: 'limit_price',
            width: 280,
            editable: true,
            sorter: (a, b) => a['limit_price'].localeCompare(b['limit_price']),
        },
        {
            title: '直接下单',
            dataIndex: 'is_plan',
            width: 280,
            editable: true,
            sorter: (a, b) => a['is_plan'].localeCompare(b['is_plan']),
        },
        {
            title: 'CID',
            dataIndex: 'cid',
            width: 280,
            sorter: (a, b) => a['cid'].localeCompare(b['cid']),
        },
        {
            title: '是否开启CID',
            dataIndex: 'is_cid',
            width: 120,
            editable: true,
            sorter: (a, b) => a['is_cid'].localeCompare(b['is_cid']),
        },
        {
            title: 'cid次数',
            dataIndex: 'get_cid_times',
            width: 120,
            editable: true,
            sorter: (a, b) => a?.get_cid_times - b?.get_cid_times,
        },
        {
            title: 'CID账号',
            dataIndex: 'fake_account',
            width: 120,
            sorter: (a, b) => a?.get_cid_times - b?.get_cid_times,
        },
        {
            title: 'CID更新时间',
            dataIndex: 'update_cid_time',
            // width: 120,
            sorter: (a, b) => a['update_cid_time'].localeCompare(b['update_cid_time']),
        },
        {
            title: '限制天数',
            dataIndex: 'limit_day',
            editable: true,
            sorter: (a, b) => a?.limit_day - b?.limit_day,
        },
        {
            title: 'CID分组',
            dataIndex: 'cid_group',
            editable: true,
            sorter: (a, b) => a?.cid_group - b?.cid_group,
        },
        {
            title: '分组',
            dataIndex: 'group_id',
            editable: true,
            sorter: (a, b) => a?.group_id - b?.group_id,
        },
        {
            title: '操作',
            width: 120,
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            保存
                        </Typography.Link>
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        修改
                    </Typography.Link>
                );
            },
        },
    ];

    const renderSearch = ({ current, pageSize }) => {
        let params = formSearch.getFieldsValue();
        params.per_page = pageSize;
        setSize(pageSize);
        setPage(current);
        params.page = current;
        ajax.get('/maersk/book/task?group_id=1000', { params })
            .then((response) => {
                if (response.data) {
                    response.data.map((item) => {
                        if (item.is_order === 0) {
                            item.is_order = '关闭';
                        } else if (item.is_order === 1) {
                            item.is_order = '开启';
                        }
                        if (item.is_USA === 0) {
                            item.is_USA = '否';
                        } else if (item.is_USA === 1) {
                            item.is_USA = '是';
                        }
                        if (item.is_plan === 0) {
                            item.is_plan = '否';
                        } else if (item.is_plan === 1) {
                            item.is_plan = '是';
                        }
                        if (item.is_cid == 0) {
                            item.is_cid = '关闭';
                        } else if (item.is_cid == 1) {
                            item.is_cid = '常规初始化';
                        } else if (item.is_cid == 2) {
                            item.is_cid = '加载更多初始化';
                        } else {
                            item.is_cid = item.is_cid ? item.is_cid : '';
                        }
                        item.update_cid_time = item.update_cid_time ? item.update_cid_time : '';
                        item.route_select = item.route_select ? item.route_select : '';
                        return item;
                    });
                    setData(response.data);
                    setTol(response.pagination.total);
                } else if (response == undefined) {
                    response = [];
                    setData(response);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                openTypeSelect: col.dataIndex === 'is_order' ? 'select' : 'text',
                PlanSelect: col.dataIndex === 'is_plan' ? 'select' : 'text',
                openTypeUSA: col.dataIndex === 'is_USA' ? 'select' : 'text',
                CIDTypeSelect: col.dataIndex === 'is_cid' ? 'select' : 'text',
                inputTypeBox: col.dataIndex === 'box_type' ? 'select' : 'text',
                inputTypeStart: col.dataIndex === 'origincity_name' ? 'select' : 'text',
                inputTypeEnd: col.dataIndex === 'destinationcity_name' ? 'select' : 'text',
                inputTypeDate: col.dataIndex === 'order_date' ? 'date' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    // 获取多选的id
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // 多选
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 50,
    };

    const onMenuClick = () => {
        if (selectedRowKeys.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error('请选择要修改的数据');
        }
    };

    const handleOk = () => {
        // setIsModalOpen(false);
        const prm = newForm.getFieldsValue();
        if (prm.is_order === '开启') {
            prm.is_order = 1;
        } else if (prm.is_order === '关闭') {
            prm.is_order = 0;
        }
        if (prm.is_USA === '是') {
            prm.is_USA = 1;
        } else if (prm.is_USA === '否') {
            prm.is_USA = 0;
        }
        if (prm.is_plan === '是') {
            prm.is_plan = 1;
        } else if (prm.is_plan === '否') {
            prm.is_plan = 0;
        }
        if (prm.is_add_data === '是') {
            prm.is_add_data = 1;
        } else if (prm.is_add_data === '否') {
            prm.is_add_data = 0;
        }
        if (prm.is_cid === '常规初始化') {
            prm.is_cid = 1;
        } else if (prm.is_cid === '关闭') {
            prm.is_cid = 0;
        } else if (prm.is_cid === '加载更多初始化') {
            prm.is_cid = 2;
        } else if (prm.is_cid === '3') {
            prm.is_cid = 3;
        }
        prm.ids = selectedRowKeys.toString().replaceAll(',', ', ');

        ajax.post('/maersk/group/task', prm)
            .then((response) => {
                message.success('修改成功');
                newForm.resetFields();
                setSelectedRowKeys([]);
                setIsModalOpen(false);
                loading();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleCancel = () => {
        newForm.resetFields();
        setSelectedRowKeys([]);
        setIsModalOpen(false);
    };

    const onShowSizeChange = (row) => {
        renderSearch(row);
    };

    const newOnChange = (val) => {
        newForm.setFieldsValue({
            order_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <PageHeader title="ApiTask列表" sticky></PageHeader>

                    <Col style={{ display: 'flex' }}>
                        <Button type="primary" onClick={() => onMenuClick()}>
                            批量修改
                        </Button>
                    </Col>
                </div>
            </div>
            <Card style={{ width: '100%' }} className="ax-search-card">
                <Form form={formSearch} autoComplete="off">
                    <Row gutter={SEARCH_ITEM_GUTTER}>
                        <Col style={{ width: '13%' }}>
                            <Form.Item label="对应taskID" name="order_id">
                                <Input style={{ width: '80%' }}></Input>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '17%' }}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '17%' }}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ display: 'flex', width: '30%' }}>
                            <Form.Item style={{ width: '50%', marginRight: '5%' }} label="箱型" name="box_type">
                                <Select
                                    options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                            <Form.Item label="CID分组" name="cid_group">
                                <Input style={{ width: '70%' }}></Input>
                            </Form.Item>
                            <Form.Item label="分组" name="group_id">
                                <Input style={{ width: '70%' }}></Input>
                            </Form.Item>
                        </Col>

                        <Col style={{ display: 'flex' }}>
                            <Form.Item label="列表分组" name="list_type">
                                <Input style={{ width: '60%' }}></Input>
                            </Form.Item>
                            <span style={{ width: '40%', marginLeft: '10%' }}>
                                <Button onClick={() => renderSearch({ current: 1 })} type="primary">
                                    搜索
                                </Button>
                            </span>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Modal title="" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} closable={false}>
                <Form form={newForm} style={{ width: '80%', margin: '0 auto' }}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="对应taskID" name="order_id">
                                <Input />
                            </Form.Item>
                        </Col>
                        {/* <Col span={24}>
                            <Form.Item label="添加taskID" name="order_id_add">
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col span={24}>
                            <Form.Item label="账户" name="account_name">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="数量" name="quantity">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <div>
                                <Form.Item label="箱型" name="box_type">
                                    <Select
                                        style={{ width: 140 }}
                                        options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                        showSearch
                                        allowClear
                                    ></Select>
                                </Form.Item>
                            </div>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select style={{ width: 320 }} options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select style={{ width: 320 }} options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item label="搜索开航日" name="order_date">
                                <Space direction="vertical">
                                    <DatePicker onChange={newOnChange} format="YYYY-MM-DD" />
                                </Space>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="路由" name="route_select">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="是否开启" name="is_order">
                                <Select style={{ width: 100 }} options={createJsonOptions(['开启', '关闭'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="限价" name="limit_price">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="直接下单" name="is_plan">
                                <Select style={{ width: 100 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="美线" name="is_USA">
                                <Select style={{ width: 100 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="是否开启CID" name="is_cid">
                                <Select
                                    style={{ width: 100 }}
                                    options={createJsonOptions(['关闭', '常规初始化', '加载更多初始化', '3'])}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="cid次数" name="get_cid_times">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="限制天数" name="limit_day">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="CID分组" name="cid_group">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="分组" name="group_id">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="是否重复添加" name="is_add_data">
                                <Select style={{ width: 100 }} options={createJsonOptions(['是', '否'])} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    rowSelection={rowSelection}
                    rowKey={(record) => record.id}
                    bordered
                    dataSource={dataSource}
                    // virtual
                    // columns={mergedColumns}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        current: current,
                        pageSizeOptions: [100, 200, 500, 1000],
                    }}
                    onChange={onShowSizeChange}
                />
            </Form>
        </div>
    );
}
